import { render, staticRenderFns } from "./GlobalParameterSelector.vue?vue&type=template&id=506dec0a&scoped=true&"
import script from "./GlobalParameterSelector.vue?vue&type=script&lang=js&"
export * from "./GlobalParameterSelector.vue?vue&type=script&lang=js&"
import style0 from "./GlobalParameterSelector.vue?vue&type=style&index=0&id=506dec0a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506dec0a",
  null
  
)

export default component.exports